import { c as _c } from "react/compiler-runtime";
import type { HomeDeliveryDeliveryMode, ProductPreOrderSettings } from '../ProductInfoProductTypes';
import { format, parseISO } from 'date-fns';
import ImageComponent from '@spa/components/image-component/image.component';
import React from 'react';
import styles from './product-delivery-information.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export type HomeDeliveryInformationProps = {
  readonly isHomeDeliveryAllowed: boolean;
  readonly homeDeliveryDeliveryMode: HomeDeliveryDeliveryMode | null;
  readonly isPreOrderEnabled: boolean;
  readonly preOrderSettings: ProductPreOrderSettings | null;
  readonly releaseDate: string | null;
};
export const HomeDeliveryInformation = properties => {
  const $ = _c(19);
  const {
    formatMessage
  } = useNamespacedIntl("product-info");
  const {
    isHomeDeliveryAllowed,
    homeDeliveryDeliveryMode,
    isPreOrderEnabled,
    preOrderSettings,
    releaseDate
  } = properties;
  const isHomeDeliveryPossible = isHomeDeliveryAllowed && homeDeliveryDeliveryMode !== null;
  if (!isHomeDeliveryPossible) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <ImageComponent src="/assets/icons/info-circle.svg" height={20} width={20} alt="home delivery not available icon" className={styles["delivery-information--icon"]} />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    let t1;
    if ($[1] !== formatMessage) {
      t1 = formatMessage("deliveryUnavailableHome");
      $[1] = formatMessage;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    if ($[3] !== t1) {
      t2 = <div className={styles["delivery-information--wrapper"]}>{t0}<span className={styles["delivery-information--title"]}>{t1}</span></div>;
      $[3] = t1;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t0;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ImageComponent src="/assets/icons/check-circle-filled.svg" height={20} width={20} alt="home delivery available icon" className={styles["delivery-information--icon"]} />;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  let t1;
  if ($[6] !== formatMessage) {
    t1 = formatMessage("deliveryTitleHomeAvailable");
    $[6] = formatMessage;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== t1) {
    t2 = <span className={styles["delivery-information--title"]}>{t1}</span>;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== formatMessage || $[11] !== homeDeliveryDeliveryMode || $[12] !== isPreOrderEnabled || $[13] !== preOrderSettings || $[14] !== releaseDate) {
    t3 = isPreOrderEnabled && preOrderSettings?.isActive ? <span className={styles["delivery-information--content"]} dangerouslySetInnerHTML={{
      __html: formatMessage("deliveryTimePreOrder", {
        time: format(parseISO(releaseDate ?? preOrderSettings.validTo), "dd.MM.yyyy")
      })
    }} /> : <span className={styles["delivery-information--content"]}>{formatMessage("deliveryTime", {
        time: homeDeliveryDeliveryMode.description ?? ""
      })}</span>;
    $[10] = formatMessage;
    $[11] = homeDeliveryDeliveryMode;
    $[12] = isPreOrderEnabled;
    $[13] = preOrderSettings;
    $[14] = releaseDate;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== t2 || $[17] !== t3) {
    t4 = <div className={styles["delivery-information--wrapper"]}>{t0}{t2}{t3}</div>;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
};